<script setup lang="ts">
import { utc2local } from "@/utils";
import { onMounted } from "vue";
import AddRole from "@/components/AddRole.vue";
import { useRolesStore } from "@/stores/roles";
import { storeToRefs } from "pinia";
import CsRoleList from "@/components/CsRoleList.vue";
const roleValues = [
  "",
  "stralfors",
  "dev",
  "image",
  "cs",
  "csadm",
  "security",
  "newsletter",
];

const roles = useRolesStore();
const { devRoles, loading } = storeToRefs(roles);

onMounted(async () => {
  await roles.refresh();
});
const saveRole = async (email: string, role: string, active: boolean) => {
  await roles.updateRole(email, role, active);
};
</script>

<template>
  <h1>Account list</h1>
  <pn-spinner size="2" v-show="loading" />
  <pn-table bordered="true" v-show="!loading" striped="true">
    <table>
      <thead>
        <tr>
          <th>Email</th>
          <th>Role</th>
          <th>Last login</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="role in devRoles"
          :key="role.email"
          :class="{ isDisabled: !role.active }"
        >
          <td>
            {{ role.email }}
          </td>
          <td>
            <select
              v-model="role.role"
              @change="saveRole(role.email, role.role, role.active)"
            >
              <option v-for="r in roleValues" :key="r" :value="r">
                {{ r }}
              </option>
            </select>
          </td>
          <td>{{ utc2local(role.lastLogin) }}</td>
          <td>
            <pn-button
              v-show="role.active"
              @click="saveRole(role.email, role.role, false)"
              small="true"
              appearance="light"
            >
              Disable
            </pn-button>
            <pn-button
              v-show="!role.active"
              @click="saveRole(role.email, role.role, true)"
              small="true"
              appearance="light"
            >
              Enable
            </pn-button>
          </td>
        </tr>
      </tbody>
    </table>
  </pn-table>
  <section v-show="!loading">
    <CsRoleList />
    <AddRole />
  </section>
</template>
<style lang="scss" scoped>
select {
  width: 100px;
}
.isDisabled > td {
  text-decoration: line-through;
  background: #ddd !important;
}
</style>
